import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"plus\"><title>plus</title><path d=\"M683.5,368a16,16,0,1,0,16,16A16,16,0,0,0,683.5,368Zm9,17h-8v8h-2v-8h-8v-2h8v-8h2v8h8Z\" transform=\"translate(-667.5 -368)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol